/* Printies — custom Build a Box. Native theme build (no bundle app).
One cart line = the "Build Your Own Box" tier variant; chosen figures ride
along as line-item properties. Random fill is instant (just a number).
Adding past a tier auto-advances to the next tier (no hard cap until 50).
Figures in a coming-soon Mob (section setting soon_mobs) render disabled
with a "Landing soon" chip; their tabs show a notify-me banner whose button
opens the shared <dialog id="pt-bundle-dialog"> email form.
Tier savings are benchmarked against the $3.49 single-figure price. */
(function () {
"use strict";
var root = document.getElementById("pt-bundle");
if (!root) return;
var dataEl = document.getElementById("pt-bundle-data");
var RAW = [];
try { RAW = JSON.parse(dataEl.textContent); } catch (e) { RAW = []; }
var randomImg = "";
RAW.forEach(function (p) { if (p && p.h === root.dataset.randomHandle) randomImg = p.img || ""; });
var CATS = [["all","All"],["home","Home Mob"],["wild","Wild Mob"],["monster","Monster Mob"]];
var MOBNAMES = { home: "Home Mob", wild: "Wild Mob", monster: "Monster Mob" };
var SOON = (root.dataset.soonMobs || "").split(",").map(function (s) { return s.trim(); }).filter(Boolean);
var TIERS = [
{ n: 6,  price: "$19.99", v: root.dataset.v6, save: "$3.33 each" },
{ n: 15, price: "$29.99", v: root.dataset.v15, save: "Save 43%" },
{ n: 30, price: "$34.99", v: root.dataset.v30, save: "Save 67%", flag: "Most popular" },
{ n: 50, price: "$44.99", v: root.dataset.v50, save: "Save 74%", flag: "Best value", navy: true, gift: true }
];
var MAXN = TIERS[TIERS.length - 1].n;
var PRODUCTS = [];
RAW.forEach(function (p) {
if (!p || p._end || p.h === root.dataset.randomHandle) return;
if (!p.home && !p.wild && !p.monster) return; // box is Mob series only
var o = { t: p.t, h: p.h, img: p.img, home: !!p.home, wild: !!p.wild, monster: !!p.monster };
o.soon = false;
SOON.forEach(function (k) { if (o[k]) o.soon = true; });
PRODUCTS.push(o);
});
var tier = TIERS[0];
var tierLocked = false;   // true when the user explicitly clicked a pack size
var picks = {};           // handle -> qty
var byHandle = {};
PRODUCTS.forEach(function (p) { byHandle[p.h] = p; });
var randomQty = 0;
var activeCat = "all";
var params = null;
try { params = new URLSearchParams(location.search); } catch (e) {}
if (params) { // deep-link: /pages/build-a-box?mob=home|wild|monster preselects that tab
var mobParam = params.get("mob");
if (mobParam === "home" || mobParam === "wild" || mobParam === "monster") activeCat = mobParam;
}
var justNotified = params ? params.get("notified") === "1" : false;
var busy = false;
function goal() { return tier.n; }
function pickedCount() { var s = 0; for (var k in picks) s += picks[k]; return s; }
function total() { return pickedCount() + randomQty; }
function remaining() { return Math.max(0, goal() - total()); }
function smallestTier(n) { for (var i = 0; i < TIERS.length; i++) if (TIERS[i].n >= n) return TIERS[i]; return null; }
function addOne(kind, h) {
var nt = total() + 1;
if (nt > MAXN) { flash("50 figures is the biggest box."); return; }
if (nt > tier.n) { tier = smallestTier(nt); tierLocked = false; }
if (kind === "random") randomQty++;
else picks[h] = (picks[h] || 0) + 1;
sync();
}
function afterRemove() {
if (!tierLocked) tier = smallestTier(total()) || TIERS[0];
}
function add(h) {
if (byHandle[h] && byHandle[h].soon) { flash("That figure is part of an upcoming drop — hit Notify me above to be first in line!"); return; }
addOne("pick", h);
}
function addRandom() { addOne("random"); }
function sub(h) { if (!picks[h]) return; picks[h]--; if (!picks[h]) delete picks[h]; afterRemove(); sync(); }
function subRandom() { if (randomQty > 0) randomQty--; afterRemove(); sync(); }
root.innerHTML =
'<div class="pt-mbar"><div class="pt-mbar__prog"><i></i></div>' +
'<div class="pt-mbar__txt"><b class="pt-mnow">0</b> / <span class="pt-mgoal">6</span> figures' +
'<span class="pt-mprice">$19.99</span></div>' +
'<button type="button" class="pt-mjump">Review &amp; checkout ↓</button></div>' +
'<div class="pt-bb-head">' +
'<h1>Build your own box</h1>' +
'<p>Pick a pack size, fill it with your favourites — or hit Random Fill for a surprise.</p>' +
'<div class="pt-tiers"></div>' +
'</div>' +
'<div class="pt-bb-body">' +
'<div class="pt-main"><div class="pt-cats"></div><div class="pt-notifybar"></div><div class="pt-grid"></div></div>' +
'<aside class="pt-box">' +
'<div class="pt-bh"><h3>Your box</h3><button type="button" class="pt-clear">Clear</button></div>' +
'<div class="pt-prog"><i></i></div>' +
'<div class="pt-count"><span><b class="pt-now">0</b> / <span class="pt-goal">6</span> figures</span><b class="pt-price">$19.99</b></div>' +
'<div class="pt-random">' +
'<img class="pt-rthumb" src="' + randomImg + '" alt="">' +
'<div class="pt-rt"><b>Random Printie</b>Surprise me with picks</div>' +
'<button class="pt-rminus" aria-label="less">–</button>' +
'<input class="pt-rinput" type="number" min="0" value="0">' +
'<button class="pt-rplus" aria-label="more">+</button>' +
'</div>' +
'<button class="pt-fill">Random Fill (fill remaining)</button>' +
'<ul class="pt-chosen"></ul>' +
'<button class="pt-cart" disabled>Add box to cart</button>' +
'<div class="pt-hint"></div>' +
'</aside>' +
'</div>';
var elTiers = root.querySelector(".pt-tiers");
var elCats  = root.querySelector(".pt-cats");
var elGrid  = root.querySelector(".pt-grid");
var elNbar  = root.querySelector(".pt-notifybar");
var elNow   = root.querySelector(".pt-now");
var elGoal  = root.querySelector(".pt-goal");
var elPrice = root.querySelector(".pt-price");
var elBar   = root.querySelector(".pt-prog i");
var elChosen= root.querySelector(".pt-chosen");
var elCart  = root.querySelector(".pt-cart");
var elHint  = root.querySelector(".pt-hint");
var elFill  = root.querySelector(".pt-fill");
var elRin   = root.querySelector(".pt-rinput");
var elMbar  = root.querySelector(".pt-mbar i");
var elMnow  = root.querySelector(".pt-mnow");
var elMgoal = root.querySelector(".pt-mgoal");
var elMprice= root.querySelector(".pt-mprice");
var elMjump = root.querySelector(".pt-mjump");
var elBox   = root.querySelector(".pt-box");
var elClear = root.querySelector(".pt-clear");
var elDialog = document.getElementById("pt-bundle-dialog");
if (elDialog) {
var dx = elDialog.querySelector(".pt-ndialog__x");
if (dx) dx.onclick = function () { elDialog.close(); };
elDialog.addEventListener("click", function (e) { if (e.target === elDialog) elDialog.close(); });
}
function openNotifyDialog(cat) {
if (!elDialog) return;
var mob = MOBNAMES[cat] || cat;
var mobEl = elDialog.querySelector(".pt-nd-mob");
if (mobEl) mobEl.textContent = "the " + mob;
var tagsInput = elDialog.querySelector('input[name="contact[tags]"]');
if (tagsInput) tagsInput.value = "prospect,notify-" + cat + "-mob";
var retInput = elDialog.querySelector('input[name="return_to"]');
if (retInput) retInput.value = location.pathname + "?mob=" + cat + "&notified=1";
elDialog.showModal();
}
elClear.onclick = function () { picks = {}; randomQty = 0; tierLocked = false; tier = TIERS[0]; sync(); };
elMjump.onclick = function () {
  if (elBox) elBox.scrollIntoView({ behavior: "smooth", block: "start" });
  if (!elCart.disabled) setTimeout(function () { elCart.focus(); }, 350);
};
function renderNotifyBar() {
if (SOON.indexOf(activeCat) === -1) { elNbar.className = "pt-notifybar"; elNbar.innerHTML = ""; return; }
var mob = MOBNAMES[activeCat] || activeCat;
elNbar.className = "pt-notifybar is-on";
if (justNotified) {
elNbar.innerHTML = '<p class="pt-nb__ok">🎉 You’re on the list — we’ll email you the moment the ' + mob + ' drops!</p>';
return;
}
elNbar.innerHTML = '<p class="pt-nb__h">🔔 The ' + mob + ' hasn’t dropped yet</p>' +
'<p class="pt-nb__p">Browse the crew below — and be first in line when they go live.</p>' +
'<button type="button" class="pt-nb__btn">Notify me when it drops</button>';
var nbtn = elNbar.querySelector(".pt-nb__btn");
if (nbtn) { var cat = activeCat; nbtn.onclick = function () { openNotifyDialog(cat); }; }
}
TIERS.forEach(function (tr) {
var b = document.createElement("button");
b.type = "button";
b.className = "pt-tier";
b.innerHTML =
(tr.flag ? '<span class="pt-tier__flag' + (tr.navy ? ' pt-tier__flag--navy' : '') + '">' + tr.flag + '</span>' : '') +
"<b>" + tr.n + "</b><small>figures</small><span>" + tr.price + "</span>" +
(tr.save ? '<em class="pt-tier__save">' + tr.save + '</em>' : '') +
(tr.gift ? '<i class="pt-tier__gift">🎁 free mystery gift</i>' : '');
b.onclick = function () {
tier = tr; tierLocked = true;
while (total() > goal()) { // trim overflow if shrinking
if (randomQty > 0) randomQty--;
else { for (var k in picks) { picks[k]--; if (!picks[k]) delete picks[k]; break; } }
}
sync();
};
elTiers.appendChild(b);
});
CATS.forEach(function (c) {
var has = c[0] === "all" ? true
: PRODUCTS.some(function (p) { return p[c[0]]; });
if (!has) return;
var b = document.createElement("button");
b.className = "pt-cat" + (c[0] === activeCat ? " is-active" : "");
b.textContent = c[1];
b.onclick = function () {
activeCat = c[0];
Array.prototype.forEach.call(elCats.children, function (x) { x.classList.remove("is-active"); });
b.classList.add("is-active");
renderNotifyBar();
renderGrid();
};
elCats.appendChild(b);
});
function visible() {
var list = PRODUCTS.filter(function (p) {
if (activeCat === "all") return true;
return !!p[activeCat];
});
return list.slice().sort(function (a, b) { return (a.soon ? 1 : 0) - (b.soon ? 1 : 0); });
}
function renderGrid() {
elGrid.innerHTML = "";
visible().forEach(function (p) {
var q = picks[p.h] || 0;
var card = document.createElement("div");
card.className = "pt-card" + (q ? " is-picked" : "") + (p.soon ? " is-soon" : "");
var act;
if (p.soon) {
act = '<span class="pt-soonchip">Landing soon</span>';
} else {
act = q
? '<div class="pt-step"><button class="pt-minus">–</button><b>' + q + '</b><button class="pt-plus">+</button></div>'
: '<button class="pt-add">Add</button>';
}
card.innerHTML =
'<img loading="lazy" src="' + (p.img || "") + '" alt="' + p.t + '">' +
'<div class="pt-t">' + p.t + '</div>' +
'<div class="pt-act">' + act + '</div>';
card.querySelector(".pt-add") && (card.querySelector(".pt-add").onclick = function () { add(p.h); });
card.querySelector(".pt-plus") && (card.querySelector(".pt-plus").onclick = function () { add(p.h); });
card.querySelector(".pt-minus") && (card.querySelector(".pt-minus").onclick = function () { sub(p.h); });
elGrid.appendChild(card);
});
}
root.querySelector(".pt-rplus").onclick = addRandom;
root.querySelector(".pt-rminus").onclick = subRandom;
elRin.onchange = function () {
var n = parseInt(elRin.value, 10); if (isNaN(n) || n < 0) n = 0;
var maxAdd = MAXN - pickedCount();
if (n > maxAdd) n = maxAdd;
randomQty = n;
if (total() > tier.n && !tierLocked) tier = smallestTier(total()) || TIERS[0];
if (total() < tier.n) afterRemove();
sync();
};
elFill.onclick = function () { randomQty += remaining(); sync(); };
function renderChosen() {
elChosen.innerHTML = "";
var any = false;
for (var h in picks) {
any = true;
var p = byHandle[h];
var li = document.createElement("li");
li.innerHTML =
'<img src="' + (p.img || "") + '" alt=""><span class="pt-cn">' + p.t + '</span>' +
'<div class="pt-cstep"><button class="pt-cminus" aria-label="remove one">–</button><b>' + picks[h] + '</b><button class="pt-cplus" aria-label="add one">+</button></div>' +
'<button class="pt-x" aria-label="remove">×</button>';
(function (hh) {
li.querySelector(".pt-cminus").onclick = function () { sub(hh); };
li.querySelector(".pt-cplus").onclick = function () { add(hh); };
li.querySelector(".pt-x").onclick = function () { delete picks[hh]; afterRemove(); sync(); };
})(h);
elChosen.appendChild(li);
}
if (randomQty > 0) {
any = true;
var lir = document.createElement("li");
lir.innerHTML =
'<img src="' + randomImg + '" alt="Random Printie"><span class="pt-cn">Random Printie</span>' +
'<div class="pt-cstep"><button class="pt-rcminus" aria-label="remove one">–</button><b>' + randomQty + '</b><button class="pt-rcplus" aria-label="add one">+</button></div>' +
'<button class="pt-x" aria-label="remove">×</button>';
lir.querySelector(".pt-rcminus").onclick = subRandom;
lir.querySelector(".pt-rcplus").onclick = addRandom;
lir.querySelector(".pt-x").onclick = function () { randomQty = 0; afterRemove(); sync(); };
elChosen.appendChild(lir);
}
if (!any) elChosen.innerHTML = '<div class="pt-empty">Nothing in your box yet — start adding figures.</div>';
}
function flash(msg) { elHint.textContent = msg; clearTimeout(flash._t); flash._t = setTimeout(function () { elHint.textContent = ""; }, 2500); }
function sync() {
var t = total(), g = goal();
elNow.textContent = t; elGoal.textContent = g; elPrice.textContent = tier.price;
elMnow.textContent = t; elMgoal.textContent = g; elMprice.textContent = tier.price;
elMjump.textContent = t === g ? "Review & checkout ↓" : "Review box (" + t + "/" + g + ") ↓";
elMjump.classList.toggle("is-ready", t === g);
var pct = Math.min(100, (t / g) * 100) + "%";
elBar.style.width = pct; elMbar.style.width = pct;
elRin.value = randomQty;
elFill.disabled = remaining() === 0;
elFill.textContent = remaining() === 0 ? "Pack full — add more for the next size" : "Random Fill (" + remaining() + " to go)";
elCart.disabled = t !== g;
elCart.textContent = t === g ? "Add box to cart — " + tier.price : "Add " + (g - t) + " more";
Array.prototype.forEach.call(elTiers.children, function (c, i) { c.classList.toggle("is-active", TIERS[i] === tier); });
renderGrid();
renderChosen();
}
elCart.onclick = function () {
if (busy || total() !== goal()) return;
busy = true; elCart.textContent = "Adding…"; elCart.disabled = true;
var parts = [], handles = [];
for (var h in picks) {
parts.push(byHandle[h].t + (picks[h] > 1 ? " ×" + picks[h] : ""));
handles.push(h + ":" + picks[h]);
}
if (randomQty > 0) { parts.push("Random Printie ×" + randomQty); handles.push("random:" + randomQty); }
var props = { "Contents": parts.join(", ") };
if (randomQty > 0) props["Random Printies"] = String(randomQty);
props["_contents"] = handles.join(",");
fetch("/cart/add.js", {
method: "POST",
headers: { "Content-Type": "application/json", "Accept": "application/json" },
body: JSON.stringify({ items: [{ id: Number(tier.v), quantity: 1, properties: props }] })
}).then(function (r) {
if (!r.ok) throw new Error("add failed " + r.status);
return r.json();
}).then(function () {
window.location.href = "/cart";
}).catch(function (e) {
busy = false; flash("Could not add to cart — " + e.message); sync();
});
};
renderNotifyBar();
sync();
})();
